import { Component, OnInit } from '@angular/core';
import { NavigationConstant } from 'src/app/shared/constant/navigation.constant';
import { Router } from '@angular/router';
import { BriSyariahStorage } from 'src/app/shared/storage/bri-syariah.storage';

@Component({
  selector: 'app-payment-result-bri-syariah',
  templateUrl: './payment-result-bri-syariah.component.html',
  styleUrls: ['./payment-result-bri-syariah.component.css']
})
export class PaymentResultBriSyariahComponent implements OnInit {
  imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/success.png';
  paymentResult = 'Success';
  isSuccess = true;

  failedReason;

  invoiceNumber: string;
  transactionDate: string;
  merchantName: string;
  transactionAmount: string;
  phoneNumber: string;
  transactionId: string;
  customerName: string;
  vaNumber: number;

  constructor(
    private router: Router,
    private storage: BriSyariahStorage,
  ) { }

  ngOnInit(): void {
    if (this.storage.data == null) {
      this.router.navigate([NavigationConstant.BRISYARIAH_INQUIRY]);
    }

    this.transactionAmount = this.storage.data.amount;
    this.customerName = this.storage.data.customer_name;
    let responseCode = this.storage.data.status;
    this.vaNumber = this.storage.data.virtual_account;


    if (responseCode !== '000') {
      this.paymentResult = 'Failed';
      this.imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/fail.png';
      this.isSuccess = false;

      this.mapResponse(responseCode);

    }

  }

  goToInquiry() {
    this.router.navigate([NavigationConstant.BRISYARIAH_INQUIRY]);
  }

  mapResponse(responseCode) {
    switch (responseCode) {
      case '500':
        this.failedReason = 'Transaction Failed';
        break;

      default:
        this.failedReason = 'Unknown Error';
        break;
    }
  }

}
